import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { Pill } from "src/base-components/Pill";
import { Agent } from "src/clients/agent-management";

type AgentCardProps = {
  agent: Agent;
  onClick: () => void;
};

export const AgentCard: React.FC<AgentCardProps> = ({ agent, onClick }) => {
  const publishedCount = agent.published_versions_count ?? 0;
  const draftCount = agent.draft_versions_count ?? 0;

  return (
    <li
      className={twJoin(
        "group cursor-pointer rounded-lg border border-gray-200 p-4",
      )}
      data-loc={`agent-card-${agent.id}`}
      onClick={onClick}
    >
      <h4 className="mb-2 font-inter-semibold-13px text-gray-800">
        {agent.name}
      </h4>
      <p className="mb-4 line-clamp-3 whitespace-pre-line font-inter-normal-12px text-gray-500">
        {agent.description || "No description"}
      </p>
      <div className="flex flex-wrap gap-1">
        {publishedCount > 0 && (
          <Pill variant="green">
            <Pill.Icon icon={faCircle} size="sm" />
            <Pill.Text>{publishedCount} Published</Pill.Text>
          </Pill>
        )}
        {draftCount > 0 && (
          <Pill variant="yellow">
            <Pill.Text>{draftCount} Draft</Pill.Text>
          </Pill>
        )}
      </div>
    </li>
  );
};
